module.exports = __webpack_public_path__ + "img/hear_no_evil.13424ef5.png";